module.exports = __webpack_public_path__ + "img/united-states.a8eb3787.png";